import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function AuthCallback() {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuth();

  useEffect(() => {
    // Esperar a que termine de cargar
    if (loading) {
      return;
    }

    // Si la sesión existe, continuar aunque falle la carga del perfil.
    if (user) {
      if (profile?.role === 'admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } else {
      // Si no hay usuario después de cargar, algo salió mal
      navigate('/login', { replace: true });
    }
  }, [user, profile, loading, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-500 to-fuchsia-600 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-white mx-auto"></div>
        <p className="mt-4 text-white text-lg">Completando inicio de sesión...</p>
      </div>
    </div>
  );
}
